var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m.522 1.85.975 9.75a1 1 0 0 0 .995.9h7.973a1 1 0 0 0 .995-.9l.975-9.75a.1.1 0 0 0-.158-.091l-3.53 2.52a.1.1 0 0 1-.147-.036L6.568.18a.1.1 0 0 0-.18 0L4.358 4.243a.1.1 0 0 1-.148.037L.68 1.759a.1.1 0 0 0-.157.091Z",
  fill: "#E29C09"
})));
export default SvgVip;